 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		133: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~block-10~block-11~block-13~block-15~block-16~block-4~block-43~block-45~block-58~block-59~blo~ef004e54","1":"vendors~block-11~block-16~block-4~block-58~block-60~block-79~block-88~page-6~page-7","2":"vendors~page-3~page-6~page-7~widget-15~widget-16~widget-17~widget-22~widget-6","3":"vendors~page-6~page-7~widget-15~widget-16~widget-17~widget-22~widget-6","4":"vendors~block-16~block-43~block-45~block-58~block-63~block-88","5":"vendors~page-3~widget-15~widget-16~widget-17","6":"vendors~block-58~block-60~block-79","7":"vendors~page-3~widget-2~widget-3","8":"block-43~block-63","9":"vendors~block-8~block-88","10":"vendors~page-4~widget-13","11":"block-0","12":"block-1","13":"block-10","14":"block-100","15":"block-101","16":"block-102","17":"block-103","18":"block-104","19":"block-105","20":"block-106","21":"block-107","22":"block-108","23":"block-109","24":"block-11","25":"block-110","26":"block-111","27":"block-112","28":"block-12","29":"block-13","30":"block-14","31":"block-15","32":"block-16","33":"block-17","34":"block-18","35":"block-19","36":"block-2","37":"block-20","38":"block-21","39":"block-22","40":"block-23","41":"block-24","42":"block-25","43":"block-26","44":"block-27","45":"block-28","46":"block-29","47":"block-3","48":"block-30","49":"block-31","50":"block-32","51":"block-33","52":"block-34","53":"block-35","54":"block-36","55":"block-37","56":"block-38","57":"block-39","58":"block-4","59":"block-40","60":"block-41","61":"block-42","62":"block-43","63":"block-44","64":"block-45","65":"block-46","66":"block-47","67":"block-48","68":"block-49","69":"block-5","70":"block-50","71":"block-51","72":"block-52","73":"block-53","74":"block-54","75":"block-55","76":"block-56","77":"block-57","78":"block-58","79":"block-59","80":"block-6","81":"block-60","82":"block-61","83":"block-62","84":"block-63","85":"block-64","86":"block-65","87":"block-66","88":"block-67","89":"block-68","90":"block-69","91":"block-7","92":"block-70","93":"block-71","94":"block-72","95":"block-73","96":"block-74","97":"block-75","98":"block-76","99":"block-77","100":"block-78","101":"block-79","102":"block-8","103":"block-80","104":"block-81","105":"block-82","106":"block-83","107":"block-84","108":"block-85","109":"block-86","110":"block-87","111":"block-88","112":"block-89","113":"block-9","114":"block-90","115":"block-91","116":"block-92","117":"block-93","118":"block-94","119":"block-95","120":"block-96","121":"block-97","122":"block-98","123":"block-99","124":"page-0","125":"page-1","126":"page-2","127":"page-3","128":"page-4","129":"page-5","130":"page-6","131":"page-7","135":"theme-switcher","136":"vendors~block-91","137":"vendors~page-4","138":"vendors~widget-4","139":"widget-0","140":"widget-1","141":"widget-10","142":"widget-11","143":"widget-12","144":"widget-13","145":"widget-14","146":"widget-15","147":"widget-16","148":"widget-17","149":"widget-18","150":"widget-19","151":"widget-2","152":"widget-20","153":"widget-21","154":"widget-22","155":"widget-23","156":"widget-24","157":"widget-3","158":"widget-4","159":"widget-5","160":"widget-6","161":"widget-7","162":"widget-8","163":"widget-9"}[chunkId]||chunkId) + "." + "54045b32e2d524d616d2" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 436);
